import { AUTH0_MFA_TYPES } from '../../../../../../authentication/constants';

const getMask = (emailPart, numVisibleCharacters) => {
  const partLength = emailPart.length;
  return partLength > numVisibleCharacters
    ? `${emailPart.substring(0, numVisibleCharacters)}${'*'.repeat(partLength - numVisibleCharacters)}`
    : '*'.repeat(numVisibleCharacters);
};

export const getEnrollmentName = (selectedType, value, countryCode) => {
  if (!value) {
    return '';
  }
  const numVisibleCharacters = 4;
  if (selectedType === AUTH0_MFA_TYPES.email) {
    const split = value.split('@');
    return `${getMask(split[0], numVisibleCharacters)}@${getMask(split[1], numVisibleCharacters)}`;
  }

  const smsLength = (countryCode?.code?.length || 0) + value.length;
  return smsLength > numVisibleCharacters
    ? `${'*'.repeat(smsLength - numVisibleCharacters)}${value.substring(smsLength - 3)}`
    : '*'.repeat(numVisibleCharacters);
};
